var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#0E1621"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 32,
    height: 32,
    fill: "url(#pattern0_1168_221)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1168_221",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1168_221",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1168_221",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEEElEQVR4nO2czYscRRjG2w9U/AsEET8O6k09xy8U9CAiWe9e4wfq2Y8/QEhA8Oa/4Gn1EAx6SlAM5BDirIcF2ctMP8/Tu0pIFNwcbKl1IhqnZqa7q7eY7ucHBcvsdtX0U2+99dZbtVUUxhhjjDHGGGOMGSF1Xd9WVdVTJD8W8K3In0j+Gkr4OXxG8qPwN7m/6+CEl/S6yB2R9ZplImkrPJv7+280AB4SebGB8LeWH0Idud9jI5F0QgA7iH+zHAB4Iff7bBQkTxK4kUD8m+WwKstnc7/XRlABr4j8I6H4/4wEko/kfr/Nt3zgisry7aqqHt3b27snlP3p9DEB74j8ccWz33tibi/+oaS36rq+PVZH+N28Iw5j9YR2Ys+PFq4Qn8D1qiyfa1Dfi0s6YeJR0FB8SU8XDZmPhMWjSXqyaX1jnXB/A/B8m7qDOyJwOeKGPizGDnuy/H8j4N1I3eeKMcM1oh0C53d3d+/u0s7+bPZ4bB4oxkrVIM4n8HUIM9u2FZ6N1P1LMUaqFousLp0wm83ujS3KirHBDukFkmfbuCO7oAYTLoELqTuhAt4b/SRcrRlqTiaTu0R+lcod1XV9R3QPAfigGANsGGoGCw+WnmIkxELQ+ULsiWLosGWcn6ITwoiKpiKAK4NPRUjaWjHhLl3hdnFHYSOHwLUlnfdaMWSYaIXbZiSEeo/qj7f93aCtXx0tv8tIWGX5863Jh4uhwp5yO2uNBODCCsu/MegtSSW2/DYjYZn4g96EUc/id+kEi8804rfphMGLz9U+/1rXfH50TgDOj1p8HZPbibS9PM63+LT4fSFbfj5k8S2+7PPpCdduh4525FDTE24xVBztZMTiZ8TiZ8TiZ8TiZ8TiZ8TiZ8TiZ8TiZ8TiZ8TiZ0TSyzk20Nc8LjjsDfTpdPpAOJZn8TNB8jOfXsjE/AzNVbudTMzvTFjod3P6fElbxRgQcGahEMB2L+3J4v9XkHCb4CIrJE/1IP6JUZ9Yi0Q/C8Uoy/LBlG3J4v8fkm8exz0JsvgRYYAvI67gtMXvmXCOPuaPU13hKFt+8/AzHBvvegVMwOJnDD9ly19DpMgdCV3DT1n8fOGnLP56BCuPdMBOW/Gr2ewZpxfWtVRgO+L/zzQRPYwWhs4EtlfsJYwnt9Nn+FnX9Z1HuRzyE5KXCPy57D8RR5leSB1+SrpP0hskv4ilrWXx04Wfbaxctvwk4efZuS+P5ukblH1JLzX4WuMgTJoJxF1m9VcFfHpwcHB/7nfdtOxn+wL8LOBzAK+mSGGMMvvZsPwu4BuS76feMxg84TrelqLvhMk7RFAhjM39HhvLsrM/t/jy60cTMnnKVn4cIejfZRI2Ymzl/a+CTx+FiWE02MqNMcYYY4wxxhhTNOUvGi3rD9quDrkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.6b755a2f80cfdc61d38d3cd76a5d302b.svg";
export { ForwardRef as ReactComponent };